module.exports = __webpack_public_path__ + "static/media/icon-social--fb.8ede84ce.svg";